export default __webpack_public_path__ + "static/wave-d5e4f024d0c93f3bede9f71f741a37f2.png";